import {
  Button,
  createStyles,
  Dialog,
  TextField,
  Theme,
  WithStyles,
  withStyles,
  Drawer,
  Divider,
  AppBar,
  CssBaseline,
  Toolbar,
  IconButton,
  Typography,
  MenuItem,
  Box,
  Chip,
  Fab,
  FormControlLabel,
  Switch,
  FormHelperText,
  ButtonBase,
  Paper,
  Tabs,
  Tab,
  List,
  Checkbox,
  Grid,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListItemIcon,
  Avatar,
} from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import * as React from "react";
import CloseIcon from "@material-ui/icons/Close";
import { Form, Formik } from "formik";
import ItemHeaderDialog from "./ItemHeaderDialog";
import ItemLegendDialog from "./ItemLegendDialog";
import ItemSignotoriesDialog from "./ItemSignotoriesDialog";
import AddInspectionItemDialog from "./AddInspectionItemDialog";
import AddIcon from "@material-ui/icons/Add";
import InspectionCardComponent from "../components/InspectionCardComponent";
import {
  isEmpty,
  getAcronym,
  CAPTURE_TYPE,
  getCategories,
  getUniqueNames,
  getUniquMachineNumbers,
  getUniqueTypes,
  convertTextToTitleCase,
  convertToBoolean,
  APPLICATION_TYPE,
  getPositionFromKey,
  WMS_OPERATION_TYPE,
} from "../constants/constants";
import { AssetsService } from "../services/AssetsService";
import imagePlacholder from "../assets/images/image-placeholder.png";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import RenderImagesDialog from "./RenderImagesDialog";
import LoadingComponents from "../components/LoadingComponents";
import TabPanel from "../components/TabPanel";
import emptyTrash from "../assets/images/empty_trash.png";
import GenericDialog from "./GenericDialog";
import { types } from "./AddCompanyDialog";
import { defaultTheme } from "../utils/theme";
import AddFormsItemDialog from "./AddFormsItemDialog";
import FormsCardComponent from "../components/FormsCardComponent";
import { InspectionService } from "../services/InspectionService";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import EditIcon from "@material-ui/icons/Edit";
import update from "immutability-helper";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import MyTextCard from "../components/MyTextCard";
import {
  SortableContainer as sortableContainer,
  SortableElement as sortableElement,
  SortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ChipComponent from "../components/ChipComponent";
const drawerWidth = "30%";
const DragHandle = SortableHandle(() => (
  <ListItemIcon>
    <DragHandleIcon />
  </ListItemIcon>
));
interface StyledTabProps {
  label: string;
}
interface StyledTabsProps {
  value: number;
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}
const SortableItem = sortableElement((props: any) => {
  let item = props.item;
  return (
    <ListItem>
      <Paper
        style={{
          padding: 8,
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <ListItemIcon>
          <Avatar>{props.value + 1}</Avatar>
        </ListItemIcon>
        <ListItemText primary={item.title} />
        <ListItemSecondaryAction style={{ padding: 10 }}>
          <DragHandle />
        </ListItemSecondaryAction>
      </Paper>
    </ListItem>
  );
});
const SortableList = sortableContainer((props: any) => {
  return (
    <List component="div">
      {props.items &&
        props.items.map((item: any, index: any) => (
          <SortableItem
            key={`item-key-sort-${index.toString()}`}
            index={index}
            item={item}
            value={index}
          />
        ))}
    </List>
  );
});
const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 40,
      width: "100%",
      backgroundColor: "orange",
    },
  },
})((props: StyledTabsProps) => (
  <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />
));
const StyledTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: "none",
      color: "black",
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.pxToRem(15),
      marginRight: theme.spacing(1),
      "&:focus": {
        opacity: 1,
      },
    },
  })
)((props: StyledTabProps) => <Tab disableRipple {...props} />);
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    tabs: {
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    appBar: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    img: {
      "max-width": 120,
      "max-height": 120,
      overflow: "hidden",
    },
    drawerPaper: {
      marginTop: 64,
      width: drawerWidth,
    },
    button: { margin: theme.spacing(2) },
    drawer: {
      [theme.breakpoints.up("sm")]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    image: {
      width: 128,
      height: 128,
      borderRadius: 10,
    },
    tabRoot: {
      flexGrow: 1,
    },
    fab: {
      position: "fixed",
      zIndex: 100,
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    section3: {
      margin: theme.spacing(3, 3, 3),
    },
    chip: {
      margin: theme.spacing(0.5),
    },
    signChip: {
      padding: 5,
      margin: 5,
      width: 180,
      height: 44,
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    content: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(3),
    },
    sorting: {
      zIndex: theme.zIndex.modal + 100,
      cursor: "row-resize",
    },
  });

interface Props extends WithStyles<typeof styles> {
  open: any;
  editData: any;
  handleClose: any;
  handleOnSave: any;
  assets: any;
  allLegends: any;
  companyData: any;
  equipments: any;
  parentWorkflowData?: any;
  workflows?: any;
}
class AddInspectionDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    sameAsAbove: false,
    openAddLegendItemDialog: false,
    openAddHeaderItemDialog: false,
    openAddNotesItemDialog: false,
    openAddInspectionItemDialog: false,
    openAddFormsItemDialog: false,
    openAddSignitoriesItemDialog: false,
    openRenderImagesDialog: false,
    isLoading: false,
    selectedTab: 0,
    valueVerticalTab: 0,
    selectedImageItem: { base64: "", item: { filename: "", _id: "" } },
    hasError: false,
    mobileOpen: false,
    editData: { questions: Array<any>() },
    formsEditData: Array<any>(),
    editDataIndex: -1,
    images: Array<any>(),
    defaultLegendItems: Array<any>(),
    defaultHeaderItems: [
      { title: "Inspection date", type: "Date" },
      { title: "Operator's name", type: "Text" },
      { title: "Machine number", type: "Number" },
    ],
    defaultSignitoriesItems: Array<any>(),
    defaultNotesItems: [{ title: "No-Go Comment", type: "Text" }],
    inspectionItems: Array<any>(),
    formsItems: Array<any>(),
    openConfirmationDialog: false,
    deletingObj: {
      index: 0,
      base64: "",
      inspectionData: { title: "" },
      formsData: Array<any>(),
    },
    showErrorDialog: false,
    changingFromQuestions: false,
    changingFromForms: false,

    equipments: Array<any>(),
    equipmentNames: Array<any>(),
    uniqueNames: Array<any>(),
    uniqueTypes: Array<any>(),
    uniqueMachineNumbers: Array<any>(),

    editingLegend: {},
    editingLegendIndex: -1,
    editingHeader: {},
    editingHeaderIndex: -1,

    editingNotes: {},
    editingNotesIndex: -1,

    editingSignature: {},
    editingSignatureIndex: -1,

    setFieldValue: Function,
  };

  componentDidMount = async () => {
    const { editData } = this.props;
    if (editData && !isEmpty(this.props.editData)) {
      this.setState(
        {
          defaultLegendItems: this.props.editData.legends,
          defaultHeaderItems: this.props.editData.headerItems,
          defaultNotesItems: this.props.editData.notesItems,
          defaultSignitoriesItems: this.props.editData.signotoriesItems,
          inspectionItems: this.props.editData.inspectionsItems,
          formsItems: this.props.editData.formsItems,
          valueVerticalTab: 0,
          equipmentNames: this.getEquipments(),
          uniqueNames: getUniqueNames(this.props.equipments),
          uniqueTypes: getUniqueTypes(this.props.equipments),
          uniqueMachineNumbers: getUniquMachineNumbers(this.props.equipments),
        },
        async () => {
          await this.getInspectionImage();
        }
      );
    } else {
      this.setDefaultItems();
    }
    this.getImages();
  };
  componentDidUpdate = async (prevProps: any, prevState: any) => {
    if (prevProps.editData !== this.props.editData) {
      if (this.props.editData && !isEmpty(this.props.editData)) {
        this.setState(
          {
            defaultHeaderItems: [...this.props.editData.headerItems],
            defaultLegendItems: [...this.props.editData.legends],
            defaultNotesItems: [...this.props.editData.notesItems],
            defaultSignitoriesItems: [...this.props.editData.signotoriesItems],
            inspectionItems: [...this.props.editData.inspectionsItems],
            formsItems: [...this.props.editData.formsItems],
            valueVerticalTab: 0,
            equipmentNames: this.getEquipments(),
            uniqueNames: getUniqueNames(this.props.equipments),
            uniqueTypes: getUniqueTypes(this.props.equipments),
            uniqueMachineNumbers: getUniquMachineNumbers(this.props.equipments),
          },
          async () => {
            await this.getInspectionImage();
          }
        );
      } else {
        this.setDefaultItems();
      }
    }
    if (prevProps.assets !== this.props.assets) {
      this.getImages();
    }
  };

  getInspectionImage = async () => {
    let imageItem = this.props.editData.imageItem;
    if (imageItem) {
      let assetsService: AssetsService = new AssetsService();
      this.setState({
        isLoading: true,
      });
      assetsService.getAsset(imageItem.filename).then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success && resp.data) {
          this.setState({
            selectedImageItem: {
              base64: resp.data,
              item: { filename: imageItem.filename, _id: imageItem._id },
            },
          });
        } else {
          this.setState({
            selectedImageItem: null,
          });
        }
      });
    }
    this.setState({
      isLoading: false,
    });
    let inspectionsItems = this.state.inspectionItems;
    let newInspectionsItems = new Array<any>();
    for (var i = 0; i < inspectionsItems.length; i++) {
      let item = inspectionsItems[i];
      if (item.imageItem) {
        item.base64 = await this.getImageBase64(item.imageItem);
      }
      newInspectionsItems.push(item);
    }
    this.setState({
      inspectionItems: newInspectionsItems,
      isLoading: false,
    });
  };

  getImageBase64 = async (imageItem: any) => {
    let assetsService: AssetsService = new AssetsService();
    let resp = await assetsService.getAsset(imageItem.filename);
    if (resp && resp.success && resp.data) {
      return resp.data;
    } else {
      return "";
    }
  };

  getImages = () => {
    const { assets } = this.props;
    // let images = this.state.images;
    if (assets) {
      let assetsService: AssetsService = new AssetsService();
      this.setState({
        isLoading: true,
      });
      let images = Array<any>();
      assets.map(async (imageItem: any) => {
        let resp = await assetsService.getAsset(imageItem.filename);
        if (resp && resp.success && resp.data) {
          let imageObj = { item: imageItem, base64: resp.data };
          images.push(imageObj);
        }
        return null;
      });
      this.setState({
        isLoading: false,
        images: images,
      });
    }
  };

  handleOnOpenRenderImages = () => {
    this.setState({
      openRenderImagesDialog: true,
    });
  };
  setDefaultItems = () => {
    this.setState({
      inspectionItems: Array<any>(),
      formsItems: Array<any>(),
      defaultLegendItems: Array<any>(),
      defaultHeaderItems: [
        { title: "Inspection date", type: "Date" },
        { title: "Operator's name", type: "Text" },
        { title: "Machine number", type: "Number" },
      ],
      defaultSignitoriesItems: [],
      defaultNotesItems: [{ title: "No-Go Comment", type: "Text" }],
      equipmentNames: this.getEquipments(),
      uniqueNames: getUniqueNames(this.props.equipments),
      uniqueTypes: getUniqueTypes(this.props.equipments),
      uniqueMachineNumbers: getUniquMachineNumbers(this.props.equipments),
    });
  };

  getEquipments = () => {
    let results = getUniqueNames(this.props.equipments).map((obj: any) => {
      return {
        label: obj.title,
        value: obj.title.replace(" ", "-").toUpperCase(),
      };
    });
    return results;
  };

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: true });
  };
  onSelect = (event: any, setFieldValue: any) => {
    switch (event.target.value) {
      case "MACHINE_INSPECTION":
        this.setState({
          defaultSignitoriesItems: [
            {
              title: "Signature",
              signatureRequired: true,
              type: "Sign",
              who: "Operator",
            },
          ],
        });
        break;
      case "VEHICLE_INSPECTION": {
        this.setState({
          defaultSignitoriesItems: [
            {
              title: "Signature",
              signatureRequired: true,
              type: "Sign",
              who: "Driver",
            },
          ],
        });
        break;
      }
      case "QUESTIONS": {
        if (this.state.formsItems && this.state.formsItems.length > 0) {
          this.setState({
            showErrorDialog: true,
            changingFromForms: true,
            changingFromQuestions: false,
            setFieldValue: setFieldValue,
          });
        } else {
          setFieldValue("captureType", "QUESTIONS");
        }
        break;
      }

      case "FORMS": {
        if (
          this.state.inspectionItems &&
          this.state.inspectionItems.length > 0
        ) {
          this.setState({
            showErrorDialog: true,
            changingFromForms: false,
            changingFromQuestions: true,
            setFieldValue: setFieldValue,
          });
        } else {
          setFieldValue("captureType", "FORMS");
        }
        break;
      }
    }
  };
  handleConfirmedDelete = () => {
    if (!this.state.deletingObj) {
      return;
    }
    let deletingObj = this.state.deletingObj;
    let inspectionsItems = this.state.inspectionItems;
    inspectionsItems.splice(deletingObj.index, 1);
    this.setState({
      inspectionItems: inspectionsItems,
      deletingObj: {},
    });
  };
  handleConfirmedFormsDelete = () => {
    if (!this.state.deletingObj) {
      return;
    }
    let deletingObj = this.state.deletingObj;
    let formsItems = this.state.formsItems;
    formsItems.splice(deletingObj.index, 1);
    this.setState({
      formsItems: formsItems,
      formsEditData: Array<any>(),
      deletingObj: {},
    });
  };

  handleDeleteQuestion = (questionItem: any, index: any) => {
    // let inspectionModel = this.props.editData;
    let inspectionItems = this.state.inspectionItems;
    if (inspectionItems) {
      inspectionItems.map((inspectionItem: any) => {
        if (inspectionItem.questions) {
          inspectionItem.questions.map((questionObj: any) => {
            if (questionObj._id === questionItem._id) {
              inspectionItem.questions.splice(index, 1);
            }
            return null;
          });
        }
        return null;
      });
      this.setState({
        inspectionItems: inspectionItems,
      });
    }
  };

  updateInspection = (values: any) => {
    let inspectionModel = values;
    inspectionModel.companyId = values.companyId;
    let inspectionsService: InspectionService = new InspectionService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    inspectionsService.editInspection(inspectionModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState(
          {
            inspectionItems: resp.inspectionsItems,
          },
          () => {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Edited Successfully",
            });
          }
        );
      } else {
        if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        }
        if (resp.message) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.message,
          });
        }
      }
    });
  };

  handleChangeCaptureType = () => {
    let setFieldValue = this.state.setFieldValue;
    if (this.state.changingFromForms) {
      this.setState(
        {
          showErrorDialog: false,
          changingFromForms: false,
          changingFromQuestions: false,
          formsItems: [],
          inspectionItems: [],
        },
        () => {
          setFieldValue("captureType", "QUESTIONS");
        }
      );
    } else {
      this.setState(
        {
          showErrorDialog: false,
          changingFromForms: false,
          changingFromQuestions: false,
          formsItems: [],
          inspectionItems: [],
        },
        () => {
          setFieldValue("captureType", "FORMS");
        }
      );
    }
  };
  renderErrorDialog = () => {
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={"Changing Capture Type"}
        open={this.state.showErrorDialog}
        message={
          this.state.changingFromQuestions
            ? "Inspection Items for Questions will be deleted? Are you sure you want to change to Forms?"
            : "Forms Items will be deleted? Are you sure you want to change to Questions?"
        }
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleChangeCaptureType()}
        handleClose={() => this.handleClose()}
      />
    );
  };
  renderConfirmDialog = () => {
    if (
      this.state.deletingObj &&
      this.state.deletingObj.inspectionData &&
      this.state.deletingObj.inspectionData.title
    ) {
      return (
        <GenericDialog
          type={types.DIALOG_INFO}
          title={`Deleting ${this.state.deletingObj.inspectionData.title}`}
          message={"Are you sure want to delete this Inspection item"}
          leftButtonName={"Cancel"}
          rightButtonName={"YES"}
          open={this.state.openConfirmationDialog}
          onCancel={() => this.handleClose()}
          onOk={() => this.handleConfirmedDelete()}
          handleClose={() => this.handleClose()}
        />
      );
    } else if (
      this.state.deletingObj &&
      this.state.deletingObj.formsData &&
      this.state.deletingObj.formsData.length > 0
    ) {
      return (
        <GenericDialog
          type={types.DIALOG_INFO}
          title={"Deleting Forms Item"}
          message={"Are you sure want to delete this Forms item"}
          leftButtonName={"Cancel"}
          rightButtonName={"YES"}
          open={this.state.openConfirmationDialog}
          onCancel={() => this.handleClose()}
          onOk={() => this.handleConfirmedFormsDelete()}
          handleClose={() => this.handleClose()}
        />
      );
    } else {
      return;
    }
  };

  renderTextInput = (
    type: String,
    id: any,
    value: any,
    handleChange: any,
    handleBlur: any,
    name: any,
    label: any,
    error: any,
    selections?: any,
    setFieldValue?: any,
    values?: any
  ) => {
    const { companyData } = this.props;
    return (
      <div>
        {type === "text" && (
          <TextField
            style={{ margin: 10 }}
            id={id}
            value={value ? value : ""}
            disabled={
              id === "uniquIdentifier" &&
              values.uniquIdentifier === getAcronym(companyData.name)
                ? true
                : false
            }
            onChange={
              id === "name"
                ? (event: any) => {
                    let nameAcronym = getAcronym(event.target.value);
                    if (values) {
                      let currentUniqueIdentifier = getAcronym(
                        companyData.name
                      );
                      setFieldValue(
                        "uniquIdentifier",
                        `${currentUniqueIdentifier}${
                          nameAcronym ? "-" + nameAcronym : ""
                        }`
                      );
                    }
                    setFieldValue("name", event.target.value);
                  }
                : handleChange
            }
            onBlur={handleBlur}
            name={name}
            label={label}
            inputProps={id === "phone" ? { maxLength: 10 } : { maxLength: 170 }}
            fullWidth
          />
        )}
        {type === "select" && (
          <TextField
            style={{ margin: 10 }}
            select
            id={id}
            label={label}
            margin="dense"
            value={value ? value : ""}
            onChange={(event) => {
              if (id === "captureType") {
                this.onSelect(event, setFieldValue);
              } else {
                setFieldValue(id, event.target.value);
                this.onSelect(event, setFieldValue);
              }
            }}
            fullWidth
          >
            {selections.map((option: any, index: any) => (
              <MenuItem key={index.toString()} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        )}
        <Typography
          variant={"subtitle1"}
          align={"right"}
          style={{
            color: "red",
            alignSelf: "right",
          }}
        >
          {error}
        </Typography>
      </div>
    );
  };

  getRetriveOptions = () => {
    const { workflows } = this.props;
    let newRetriveOption = new Array<any>();
    if (workflows && workflows.length > 0) {
      workflows.map((workflowItem: any) => {
        workflowItem.workflow.inspectionsItems.map((inspectionItem: any) => {
          inspectionItem.questions.map((questionItem: any) => {
            if (
              questionItem.responseType &&
              questionItem.responseType.title === "Options"
            ) {
              if (
                questionItem.retrieveDetails &&
                questionItem.retrieveDetails.retrieveItems
              )
                newRetriveOption.push(
                  ...questionItem.retrieveDetails.retrieveItems
                );
            }
          });
        });
      });
    }
    return newRetriveOption;
  };

  renderAllInputField = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    touched: any,
    setFieldValue: any
  ) => {
    let { classes, companyData } = this.props;
    let positions = [{ value: "Select", label: "Select" }];
    positions.push(...companyData.positions);
    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ButtonBase
            onClick={() => this.handleOnOpenRenderImages()}
            focusRipple={false}
            className={classes.image}
          >
            {this.state.selectedImageItem &&
            this.state.selectedImageItem.base64 &&
            !isEmpty(this.state.selectedImageItem.base64) ? (
              <img
                className={classes.img}
                alt="complex"
                src={`data:image/jpeg;base64,${this.state.selectedImageItem.base64}`}
              />
            ) : (
              <img
                className={classes.img}
                alt="complex"
                src={imagePlacholder}
              />
            )}
            <div
              style={{
                backgroundColor: "orange",
                color: "white",
                width: "60%",
                borderWidth: 1,
                borderRadius: 10,
                justifyContent: "center",
                alignItems: "center",
                height: 40,
                position: "absolute",
                top: 50,
                left: 25,
              }}
            >
              <CloudUploadIcon style={{ width: 15, height: 15 }} />
              <Typography
                style={{
                  fontSize: 12,
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Upload
              </Typography>
            </div>
          </ButtonBase>
        </div>
        {this.renderTextInput(
          "select",
          "captureType",
          values.captureType ? values.captureType : "",
          handleChange,
          handleBlur,
          "captureType",
          "Capture Type",
          errors.captureType,
          CAPTURE_TYPE,
          setFieldValue
        )}
        <FormControlLabel
          label="Activity Flow Applicable"
          control={
            <Checkbox
              style={{ marginLeft: 10 }}
              id={"activityflow"}
              name={"activityflow"}
              checked={values.activityflow}
              onChange={(event: any) => {
                setFieldValue("activityflow", event.target.checked);
              }}
              value="Activity Flow Applicable"
            />
          }
        />
        <FormControlLabel
          label="Breakdown Report"
          control={
            <Checkbox
              style={{ marginLeft: 10 }}
              id={"breakdown"}
              name={"Breakdown"}
              checked={values.breakdown}
              onChange={(event: any) => {
                setFieldValue("breakdown", event.target.checked);
              }}
              value="Breakdown Report"
            />
          }
        />
        <FormControlLabel
          label="Standing Report"
          control={
            <Checkbox
              style={{ marginLeft: 10 }}
              id={"standing"}
              name={"Standing"}
              checked={values.standing}
              onChange={(event: any) => {
                setFieldValue("standing", event.target.checked);
              }}
              value="Standing Report"
            />
          }
        />
        <FormControlLabel
          label="Fill Once"
          control={
            <Checkbox
              style={{ marginLeft: 10 }}
              id={"fillOnce"}
              name={"fillOnce"}
              checked={values.fillOnce}
              onChange={(event: any) => {
                setFieldValue("fillOnce", event.target.checked);
              }}
              value="Fill Once"
            />
          }
        />
        {this.props.workflows && this.props.workflows.length > 0 && (
          <FormControlLabel
            label="Link to Step Retrieve Option"
            control={
              <Checkbox
                style={{ marginLeft: 10 }}
                id={"linkedToStepRetrieveOption"}
                name={"linkedToStepRetrieveOption"}
                checked={values.fillOnce}
                onChange={(event: any) => {
                  setFieldValue(
                    "linkedToStepRetrieveOption",
                    event.target.checked
                  );
                }}
                value="Linked to Step Retrieve Option"
              />
            }
          />
        )}
        {this.renderTextInput(
          "text",
          "uniquIdentifier",
          values.uniquIdentifier,
          handleChange,
          handleBlur,
          "uniquIdentifier",
          "Unique Identifier",
          errors.uniquIdentifier,
          null,
          null,
          values
        )}
        {this.renderTextInput(
          "text",
          "name",
          values.name,
          handleChange,
          handleBlur,
          "name",
          "Inspection Name",
          errors.name,
          null,
          setFieldValue,
          values
        )}
        {this.renderTextInput(
          "select",
          "frequency",
          values.frequency ? values.frequency : "",
          handleChange,
          handleBlur,
          "frequency",
          "Inspection Frequency",
          companyData &&
            this.props.companyData.inspectionFrequencies &&
            this.props.companyData.inspectionFrequencies.length > 0
            ? errors.frequency
            : "No frequencies added on company level!!",
          companyData && this.props.companyData.inspectionFrequencies
            ? this.props.companyData.inspectionFrequencies
            : [],
          setFieldValue
        )}
        {this.renderTextInput(
          "select",
          "inspectionType",
          values.inspectionType,
          handleChange,
          handleBlur,
          "inspectionType",
          "Inspection Type",
          companyData &&
            this.props.companyData.inspectionTypes &&
            this.props.companyData.inspectionTypes.length > 0
            ? errors.inspectionType
            : "No Inspection Types added on company level!!",
          companyData && this.props.companyData.inspectionTypes
            ? this.props.companyData.inspectionTypes
            : [],
          setFieldValue
        )}
        {values.inspectionType &&
          this.renderTextInput(
            "select",
            "category",
            values.category ? values.category : "",
            handleChange,
            handleBlur,
            "category",
            "Inspection Category",
            errors.category,
            companyData && this.props.companyData.inspectionTypes
              ? getCategories(
                  this.props.companyData.inspectionTypes,
                  values.inspectionType
                )
              : [],
            setFieldValue
          )}
        {this.renderTextInput(
          "select",
          "applicationType",
          values.applicationType ? values.applicationType : "",
          handleChange,
          handleBlur,
          "applicationType",
          "Application Type",
          errors.applicationType,
          APPLICATION_TYPE,
          setFieldValue
        )}
        {values.applicationType === "wms" &&
          this.renderTextInput(
            "select",
            "operationType",
            values.operationType ? values.operationType : "",
            handleChange,
            handleBlur,
            "operationType",
            "Operation Type",
            errors.operationType,
            WMS_OPERATION_TYPE,
            setFieldValue
          )}

        {values.linkedToStepRetrieveOption && (
          <Autocomplete
            id="linkedToStepRetrieveOptionSelected"
            options={this.getRetriveOptions()}
            getOptionSelected={(option, value) => option.label === value.label}
            getOptionLabel={(option: any) => option.label}
            defaultValue={
              values.linkedToStepRetrieveOptionSelected
                ? values.linkedToStepRetrieveOptionSelected
                : []
            }
            filterSelectedOptions
            onChange={(event: any, value: any) => {
              setFieldValue("linkedToStepRetrieveOptionSelected", value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Select Retrieve Option"
                placeholder="Select Retrieve Option"
              />
            )}
          />
        )}
        <FormControlLabel
          label="Equipment Base"
          control={
            <Checkbox
              style={{ marginLeft: 10 }}
              id={"equipmentBase"}
              name={"equipmentBase"}
              checked={
                values.equipmentBase
                  ? Boolean(JSON.parse(values.equipmentBase))
                  : false
              }
              onChange={(event: any) => {
                setFieldValue("equipmentBase", event.target.checked);
                setFieldValue("roleBase", false);
                setFieldValue("rolesAssigned", []);
              }}
              value="Equipment Base"
            />
          }
        />
        <FormControlLabel
          label="Role/Position Base"
          control={
            <Checkbox
              style={{ marginLeft: 10 }}
              id={"roleBase"}
              name={"roleBase"}
              checked={
                values.roleBase ? Boolean(JSON.parse(values.roleBase)) : false
              }
              onChange={(event: any) => {
                setFieldValue("roleBase", event.target.checked);
                setFieldValue("equipmentBase", false);
                setFieldValue("equipment", "");
              }}
              value="Role/Position Base"
            />
          }
        />
        {convertToBoolean(values.equipmentBase) &&
          convertToBoolean(values.equipmentBase) &&
          this.renderTextInput(
            "select",
            "equipment",
            values.equipment,
            handleChange,
            handleBlur,
            "equipment",
            "Equipment",
            errors.equipment,
            this.state.equipmentNames,
            setFieldValue
          )}
        {convertToBoolean(values.roleBase) && (
          <Autocomplete
            multiple
            id="rolesAssigned"
            options={companyData.positions}
            getOptionSelected={(option, value) => option.label === value.label}
            getOptionLabel={(option: any) => option.label}
            defaultValue={values.rolesAssigned ? values.rolesAssigned : []}
            filterSelectedOptions
            onChange={(event: any, value: any) => {
              setFieldValue("rolesAssigned", value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Select roles"
                placeholder="Assign to"
              />
            )}
          />
        )}
        {values.inspectionType === "OTHER" &&
          this.renderTextInput(
            "text",
            "otherValue",
            values.otherValue,
            handleChange,
            handleBlur,
            "otherValue",
            "Other value",
            errors.otherValue
          )}
      </div>
    );
  };
  handleDelete = (type: String, index: number) => {
    if (type === "header") {
      let items = [...this.state.defaultHeaderItems];
      items.splice(index, 1);
      this.setState({
        defaultHeaderItems: items,
      });
    }
    if (type === "notes") {
      let items = [...this.state.defaultNotesItems];
      items.splice(index, 1);
      this.setState({
        defaultNotesItems: items,
      });
    }
    if (type === "sign") {
      let items = [...this.state.defaultSignitoriesItems];
      items.splice(index, 1);
      this.setState({
        defaultSignitoriesItems: items,
      });
    }
    if (type === "legend") {
      let items = [...this.state.defaultLegendItems];
      items.splice(index, 1);
      this.setState({
        defaultLegendItems: items,
      });
    }
  };
  handleAddLegendItem = () => {
    this.setState({ openAddLegendItemDialog: true });
  };
  handleAddHeaderItem = () => {
    this.setState({ openAddHeaderItemDialog: true });
  };
  handleAddNotesItem = () => {
    this.setState({ openAddNotesItemDialog: true });
  };
  handleAddSignitoriesItem = () => {
    this.setState({ openAddSignitoriesItemDialog: true });
  };
  handleShowPreviusLegend = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      this.setState({
        defaultLegendItems: this.props.allLegends,
      });
    } else {
      this.setState({
        defaultLegendItems: [],
      });
    }
  };
  handleAddInspectionItem = () => {
    this.setState({
      openAddInspectionItemDialog: true,
      editData: {},
      editDataIndex: -1,
    });
  };

  handleAddFormsItem = () => {
    this.setState({
      openAddFormsItemDialog: true,
      formsEditData: Array<any>(),
      editDataIndex: -1,
    });
  };

  handleClose = () => {
    this.setState({
      openAddLegendItemDialog: false,
      openAddHeaderItemDialog: false,
      openAddNotesItemDialog: false,
      openAddSignitoriesItemDialog: false,
      openAddInspectionItemDialog: false,
      openAddFormsItemDialog: false,
      openConfirmationDialog: false,
      deletingObj: {},
      showErrorDialog: false,
      changingFromForms: false,
      changingFromQuestions: false,
      editingLegend: {},
      editingLegendIndex: -1,
      editingHeader: {},
      editingHeaderIndex: -1,
      editingNotes: {},
      editingNotesIndex: -1,
      editingSignature: {},
      editingSignatureIndex: -1,
    });
  };
  handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.setState({ selectedTab: newValue });
  };
  handleVerticalTabChange = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    this.setState({ valueVerticalTab: newValue });
  };
  onItemLegendSubmit = (values: any) => {
    if (this.state.editingLegend && this.state.editingLegendIndex > -1) {
      let items = this.state.defaultLegendItems;
      items.splice(this.state.editingLegendIndex, 1, values);
      this.setState({
        defaultLegendItems: items,
        editingLegend: {},
        editingLegendIndex: -1,
        openAddLegendItemDialog: false,
      });
    } else {
      let items = [...this.state.defaultLegendItems];
      items.push(values);
      this.setState({
        defaultLegendItems: items,
        openAddLegendItemDialog: false,
      });
    }
  };
  onItemHeaderSubmit = (values: any) => {
    if (this.state.editingHeader && this.state.editingHeaderIndex > -1) {
      let items = this.state.defaultHeaderItems;
      items.splice(this.state.editingHeaderIndex, 1, values);
      this.setState({
        defaultHeaderItems: items,
        editingHeader: {},
        editingHeaderIndex: -1,
        openAddHeaderItemDialog: false,
      });
    } else {
      let items = [...this.state.defaultHeaderItems];
      items.push(values);
      this.setState({
        defaultHeaderItems: items,
        openAddHeaderItemDialog: false,
      });
    }
  };
  onItemNotesSubmit = (values: any) => {
    if (this.state.editingNotes && this.state.editingNotesIndex > -1) {
      let items = this.state.defaultNotesItems;
      items.splice(this.state.editingNotesIndex, 1, values);
      this.setState({
        defaultNotesItems: items,
        editingNotes: {},
        editingNotesIndex: -1,
        openAddNotesItemDialog: false,
      });
    } else {
      delete values.who;
      delete values.fullNameRequired;
      let items = [...this.state.defaultNotesItems];
      items.push(values);
      this.setState({
        defaultNotesItems: items,
        openAddNotesItemDialog: false,
      });
    }
  };
  onItemSignitoriesSubmit = (values: any) => {
    if (this.state.editingSignature && this.state.editingSignatureIndex > -1) {
      let items = this.state.defaultSignitoriesItems;
      items.splice(this.state.editingSignatureIndex, 1, values);
      this.setState({
        defaultSignitoriesItems: items,
        editingSignature: {},
        editingSignatureIndex: -1,
        openAddSignitoriesItemDialog: false,
      });
    } else {
      let items = [...this.state.defaultSignitoriesItems];
      items.push(values);
      this.setState({
        defaultSignitoriesItems: items,
        openAddSignitoriesItemDialog: false,
      });
    }
  };

  handleOnItemSubmit = () => {};
  handleOnTextChange = () => {};
  renderAddLegendItemDialog = () => {
    return (
      <ItemLegendDialog
        title={"Add Legend"}
        open={this.state.openAddLegendItemDialog}
        legendData={this.state.editingLegend ? this.state.editingLegend : null}
        handleClose={this.handleClose}
        handleOnSubmit={this.onItemLegendSubmit}
      />
    );
  };
  handleOnImageSelected = (imageItem: any) => {
    this.setState({
      openRenderImagesDialog: false,
      selectedImageItem: imageItem,
    });
  };
  renderImagesDialog = () => {
    return (
      <RenderImagesDialog
        open={this.state.openRenderImagesDialog}
        companyData={this.props.companyData}
        onClose={() => {
          this.setState({
            openRenderImagesDialog: false,
          });
        }}
        onSelectedItem={this.handleOnImageSelected}
        dialogTitle={"Choose Image"}
        images={this.state.images}
      />
    );
  };
  renderAddHeaderItemDialog = () => {
    return (
      <ItemHeaderDialog
        title={"Add Item Header"}
        open={this.state.openAddHeaderItemDialog}
        handleClose={this.handleClose}
        companyData={this.props.companyData}
        headerData={this.state.editingHeader ? this.state.editingHeader : null}
        handleOnSubmit={this.onItemHeaderSubmit}
        otherHeaders={this.state.defaultHeaderItems}
      />
    );
  };
  renderAddNotesItemDialog = () => {
    return (
      <ItemHeaderDialog
        title={"Add Notes Item"}
        open={this.state.openAddNotesItemDialog}
        headerData={this.state.editingNotes ? this.state.editingNotes : null}
        handleClose={this.handleClose}
        handleOnSubmit={this.onItemNotesSubmit}
      />
    );
  };
  renderAddSignotoriesItemDialog = () => {
    return (
      <ItemSignotoriesDialog
        title={"Add Signatories Item"}
        defaultValue={"Signature"}
        open={this.state.openAddSignitoriesItemDialog}
        companyData={this.props.companyData}
        handleClose={this.handleClose}
        editData={
          this.state.editingSignature ? this.state.editingSignature : null
        }
        handleOnSubmit={this.onItemSignitoriesSubmit}
      />
    );
  };
  renderAddInspectionItemDialog = () => {
    return (
      <AddInspectionItemDialog
        title={"Add Inspection Item"}
        editData={this.state.editData}
        open={this.state.openAddInspectionItemDialog}
        legends={this.state.defaultLegendItems}
        inspectionItems={this.state.inspectionItems}
        handleClose={this.handleClose}
        images={this.state.images}
        handleDeleteQuestion={this.handleDeleteQuestion}
        uniqueMachineNumbers={this.state.uniqueMachineNumbers}
        uniqueNames={this.state.uniqueNames}
        uniqueTypes={this.state.uniqueTypes}
        equipments={this.props.equipments}
        companyData={this.props.companyData}
        handleOnSubmit={
          this.state.editData && !isEmpty(this.state.editData)
            ? this.onInspectionItemEditSubmit
            : this.onInspectionItemSubmit
        }
      />
    );
  };
  renderAddFormsItemDialog = () => {
    return (
      <AddFormsItemDialog
        title={"Add Forms Item"}
        editData={this.state.formsEditData}
        open={this.state.openAddFormsItemDialog}
        handleClose={this.handleClose}
        companyData={this.props.companyData}
        uniqueMachineNumbers={this.state.uniqueMachineNumbers}
        uniqueNames={this.state.uniqueNames}
        uniqueTypes={this.state.uniqueTypes}
        equipments={this.props.equipments}
        handleOnSubmit={
          this.state.formsEditData && this.state.formsEditData.length > 0
            ? this.onFormsItemEditSubmit
            : this.onFormsItemSubmit
        }
      />
    );
  };

  renderSignotoriesChip = (item: any) => {
    let position = getPositionFromKey(item.who, this.props.companyData);
    if (position) {
      return (
        <div
          style={{
            display: "flex",
            paddingBottom: 10,
            paddingTop: 5,
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Typography variant="body1">{item.title}</Typography>
          <Typography variant="caption">
            {convertTextToTitleCase(position.label)}
          </Typography>
        </div>
      );
    }
  };
  onInspectionItemSubmit = (values: any) => {
    let _inspectionItems = this.state.inspectionItems;
    _inspectionItems.push(values);
    this.setState({
      inspectionItems: _inspectionItems,
      openAddInspectionItemDialog: false,
    });
  };
  onFormsItemSubmit = (values: any) => {
    let _formsItems = this.state.formsItems;
    _formsItems.push(values);
    this.setState({
      formsItems: _formsItems,
      openAddFormsItemDialog: false,
    });
  };
  onInspectionItemEditSubmit = (values: any) => {
    if (
      this.state.editData &&
      !isEmpty(this.state.editData) &&
      this.state.editDataIndex > -1
    ) {
      let _inspectionItem =
        this.state.inspectionItems[this.state.editDataIndex];
      let _inspectionItems = this.state.inspectionItems;
      _inspectionItem = values;
      _inspectionItems.splice(this.state.editDataIndex, 1, _inspectionItem);
      this.setState({
        inspectionItems: _inspectionItems,
        openAddInspectionItemDialog: false,
        editData: {},
        editDataIndex: -1,
      });
    }
  };
  onFormsItemEditSubmit = (values: any) => {
    if (this.state.formsEditData && this.state.formsEditData.length > 0) {
      let _formItem = this.state.formsItems[this.state.editDataIndex];
      let _formsItems = this.state.formsItems;
      _formItem = values;
      _formsItems.splice(this.state.editDataIndex, 1, _formItem);
      this.setState({
        formsItems: _formsItems,
        openAddFormsItemDialog: false,
        formsEditData: Array<any>(),
        editDataIndex: -1,
      });
    }
  };
  handleOnSubmit = (values: any) => {
    values.legends = this.state.defaultLegendItems;
    values.headerItems = this.state.defaultHeaderItems;
    values.notesItems = this.state.defaultNotesItems;
    values.signotoriesItems = this.state.defaultSignitoriesItems;
    values.inspectionsItems = this.state.inspectionItems;
    values.formsItems = this.state.formsItems;
    if (
      this.state.selectedImageItem &&
      this.state.selectedImageItem.item &&
      this.state.selectedImageItem.item.filename
    ) {
      values.imageItem = {
        filename: this.state.selectedImageItem.item.filename,
        imageId: this.state.selectedImageItem.item._id,
      };
    }
    let _copy = JSON.parse(JSON.stringify(values));
    this.setState(
      {
        inspectionItems: Array<any>(),
        formsItems: Array<any>(),
        defaultLegendItems: Array<any>(),
        defaultHeaderItems: [
          { title: "Inspection date", type: "Date" },
          { title: "Operator's name", type: "Text" },
          { title: "Machine number", type: "Number" },
        ],
        defaultSignitoriesItems: [],
        defaultNotesItems: [{ title: "No-Go Comment", type: "Text" }],
        equipmentNames: this.getEquipments(),
        uniqueNames: getUniqueNames(this.props.equipments),
        uniqueTypes: getUniqueTypes(this.props.equipments),
        uniqueMachineNumbers: getUniquMachineNumbers(this.props.equipments),
      },
      () => {
        this.props.handleOnSave(_copy);
      }
    );
  };

  executeEditComponent = (inspectionData: any, base64: any, index: any) => {
    let mEditData = inspectionData;
    mEditData.base64 = base64;
    this.setState({
      editData: mEditData,
      editDataIndex: index,
      openAddInspectionItemDialog: true,
    });
  };
  executeDeleteComponent = (inspectionData: any, base64: any, index: any) => {
    this.setState({
      openConfirmationDialog: true,
      deletingObj: {
        index: index,
        base64: base64,
        inspectionData: inspectionData,
      },
    });
  };

  executeEditFormsComponent = (formsItem: any, index: any) => {
    this.setState({
      formsEditData: formsItem,
      editDataIndex: index,
      openAddFormsItemDialog: true,
    });
  };
  executeDeleteFormsComponent = (formsItem: any, index: any) => {
    this.setState({
      openConfirmationDialog: true,
      deletingObj: {
        index: index,
        formsData: formsItem,
      },
    });
  };

  handleEditFormsItem = (item: any, index: any) => {
    this.setState({
      editData: item,
      editDataIndex: index,
      openAddFormsItemDialog: true,
    });
  };

  handleDeleteFormsItem = (item: any, index: any) => {
    this.setState({
      openConfirmationDialog: true,
      deletingObj: {
        index: index,
        formsData: item,
      },
    });
  };

  moveCard = (dragIndex: any, hoverIndex: any) => {
    const dragCard = this.state.inspectionItems[dragIndex];
    let cards = this.state.inspectionItems;
    let newCards = update(cards, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, dragCard],
      ],
    });
    this.setState({
      inspectionItems: newCards,
    });
  };

  FormRow = () => {
    const { classes } = this.props;
    return (
      <React.Fragment>
        {this.state.inspectionItems &&
          this.state.inspectionItems.length > 0 &&
          this.state.inspectionItems.map((item: any, index: any) => (
            <Grid item xs={4} key={`Key-Index-${index.toString()}`}>
              <Paper className={classes.paper}>
                <MyTextCard
                  key={index.toString()}
                  index={index}
                  id={index}
                  text={item.title}
                  moveCard={this.moveCard}
                />
              </Paper>
            </Grid>
          ))}
      </React.Fragment>
    );
  };
  onSortEnd = (oldIndex: any, newIndex: any) => {
    let inspectionItems = this.state.inspectionItems;
    let newArray = arrayMove(inspectionItems, oldIndex, newIndex);
    this.setState({
      inspectionItems: newArray,
    });
  };

  renderForm = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    touched: any,
    setFieldValue: any
  ) => {
    const { handleClose, classes } = this.props;
    // const theme = useTheme();
    return (
      <Form>
        <div className={classes.root}>
          <CssBaseline />
          <ThemeProvider theme={defaultTheme}>
            <AppBar position="fixed" className={classes.appBar}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState(
                      {
                        selectedTab: 0,
                        valueVerticalTab: 0,
                      },
                      () => {
                        handleClose();
                      }
                    );
                  }}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  Add Inspection
                </Typography>
                <Button type="submit" autoFocus color="inherit">
                  Save
                </Button>
              </Toolbar>
            </AppBar>
          </ThemeProvider>
          <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
              paper: classes.drawerPaper,
            }}
            anchor="left"
          >
            <Divider />
            <div
              style={{ paddingRight: 20, marginBottom: 100, overflow: "auto" }}
            >
              <div style={{ padding: 10 }}>
                {this.renderAllInputField(
                  values,
                  handleChange,
                  handleBlur,
                  errors,
                  touched,
                  setFieldValue
                )}
              </div>
            </div>
          </Drawer>

          <main className={classes.content}>
            <div className={classes.toolbar} />
            <Paper className={classes.tabRoot}>
              <Tabs
                value={this.state.selectedTab}
                onChange={this.handleTabChange}
                textColor="primary"
                TabIndicatorProps={{
                  style: { background: "orange", height: 3 },
                }}
              >
                <Tab label="Additional Items" />
                {values.captureType === "QUESTIONS" && (
                  <Tab label="Inspection Items" />
                )}
                {values.captureType === "FORMS" && <Tab label="Forms Items" />}
              </Tabs>
            </Paper>
            <TabPanel value={this.state.selectedTab} index={0}>
              <div style={{ width: "100%", height: "100%", overflow: "auto" }}>
                <Box display="flex" p={1} bgcolor="background.paper">
                  <Box p={1} flexGrow={1}>
                    <FormControlLabel
                      control={
                        <Switch
                          onChange={this.handleShowPreviusLegend}
                          name="checkedA"
                        />
                      }
                      label="Show available legends"
                    />
                    <FormHelperText>
                      {"Reset legends and add available legends."}
                    </FormHelperText>
                  </Box>
                </Box>
                <Box display="flex" p={1} bgcolor="background.paper">
                  <Box p={1} flexGrow={1}>
                    <Typography
                      style={{ alignSelf: "flex-start" }}
                      gutterBottom
                      variant="h5"
                    >
                      Legend Items
                    </Typography>
                  </Box>
                  <Box p={1}>
                    <Button
                      style={{ alignSelf: "flex-end" }}
                      onClick={() => this.handleAddLegendItem()}
                    >
                      Add Legend
                    </Button>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  p={1}
                  flexGrow={1}
                  bgcolor="background.paper"
                >
                  <div style={{ marginRight: 20 }}>
                    {this.state.defaultLegendItems.map(
                      (item: any, index: number) => {
                        // @FIXME -
                        //theme.palette.getContrastText(
                        //   item.inputColor
                        // );
                        let textColor = "red";
                        item.textColor = textColor;
                        return (
                          <ChipComponent
                            key={`chip-pos:${index.toString()}`}
                            title={`Legend ${item.legendCode}`}
                            item={item}
                            index={index}
                            onChipDelete={(mItem: any, nIndex: any) => {
                              this.handleDelete("legend", nIndex);
                            }}
                            ownEditDialog={(mItem: any, nIndex: any) => {
                              this.setState({
                                editingLegend: mItem,
                                editingLegendIndex: nIndex,
                                openAddLegendItemDialog: true,
                              });
                            }}
                            onChipEdit={() => {
                              this.setState({
                                editingLegend: item,
                                editingLegendIndex: index,
                                openAddLegendItemDialog: true,
                              });
                            }}
                          />
                        );
                      }
                    )}
                  </div>
                </Box>
                <Divider />
                <Box display="flex" p={1} bgcolor="background.paper">
                  <Box p={1} flexGrow={1}>
                    <Typography
                      style={{ alignSelf: "flex-start" }}
                      gutterBottom
                      variant="h5"
                    >
                      Header Items
                    </Typography>
                  </Box>
                  <Box p={1}>
                    <Button
                      style={{ alignSelf: "flex-end" }}
                      onClick={() => this.handleAddHeaderItem()}
                    >
                      Add Header Item
                    </Button>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  p={1}
                  flexGrow={1}
                  bgcolor="background.paper"
                >
                  <div style={{ marginRight: 20 }}>
                    {this.state.defaultHeaderItems.map(
                      (item: any, index: number) => (
                        <ChipComponent
                          key={`chip-pos:${index.toString()}`}
                          title={item.title}
                          item={item}
                          index={index}
                          onChipDelete={(mItem: any, nIndex: any) => {
                            this.handleDelete("header", nIndex);
                          }}
                          ownEditDialog={(mItem: any, nIndex: any) => {
                            this.setState({
                              editingHeader: mItem,
                              editingHeaderIndex: nIndex,
                              openAddHeaderItemDialog: true,
                            });
                          }}
                          onChipEdit={() => {
                            this.setState({
                              editingHeader: item,
                              editingHeaderIndex: index,
                              openAddHeaderItemDialog: true,
                            });
                          }}
                        />
                      )
                    )}
                  </div>
                </Box>
                <Divider />
                <Box display="flex" p={1} bgcolor="background.paper">
                  <Box p={1} flexGrow={1}>
                    <Typography
                      style={{ alignSelf: "flex-start" }}
                      gutterBottom
                      variant="h5"
                    >
                      Notes Items
                    </Typography>
                  </Box>
                  <Box p={1}>
                    <Button
                      style={{ alignSelf: "flex-end" }}
                      onClick={() => this.handleAddNotesItem()}
                    >
                      Add Notes Item
                    </Button>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  p={1}
                  flexGrow={1}
                  bgcolor="background.paper"
                >
                  <div style={{ marginRight: 20 }}>
                    {this.state.defaultNotesItems.map(
                      (item: any, index: number) => (
                        <ChipComponent
                          key={`chip-pos:${index.toString()}`}
                          title={item.title}
                          item={item}
                          index={index}
                          onChipDelete={(mItem: any, nIndex: any) => {
                            this.handleDelete("notes", nIndex);
                          }}
                          ownEditDialog={(mItem: any, nIndex: any) => {
                            this.setState({
                              editingNotes: mItem,
                              editingNotesIndex: nIndex,
                              openAddNotesItemDialog: true,
                            });
                          }}
                          onChipEdit={() => {
                            this.setState({
                              editingNotes: item,
                              editingNotesIndex: index,
                              openAddNotesItemDialog: true,
                            });
                          }}
                        />
                      )
                    )}
                  </div>
                </Box>
                <Divider />
                <Box display="flex" p={1} bgcolor="background.paper">
                  <Box p={1} flexGrow={1}>
                    <Typography
                      style={{ alignSelf: "flex-start" }}
                      gutterBottom
                      variant="h5"
                    >
                      Signatories Items
                    </Typography>
                  </Box>
                  <Box p={1}>
                    <Button
                      style={{ alignSelf: "flex-end" }}
                      onClick={() => this.handleAddSignitoriesItem()}
                    >
                      Add Signatories Item
                    </Button>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  p={1}
                  bgcolor="background.paper"
                  flexWrap="wrap"
                >
                  {this.state.defaultSignitoriesItems &&
                    this.state.defaultSignitoriesItems.length > 0 &&
                    this.state.defaultSignitoriesItems.map(
                      (item: any, index: number) => (
                        <Box
                          key={index.toString()}
                          alignContent="flex-start"
                          visibility={!isEmpty(item) ? "visible" : "hidden"}
                        >
                          <Chip
                            key={index.toString()}
                            size="medium"
                            className={classes.signChip}
                            onDelete={() => this.handleDelete("sign", index)}
                            label={item && this.renderSignotoriesChip(item)}
                            avatar={
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <IconButton
                                  onClick={() => {
                                    this.setState({
                                      editingSignature: item,
                                      editingSignatureIndex: index,
                                      openAddSignitoriesItemDialog: true,
                                    });
                                  }}
                                >
                                  <EditIcon
                                    style={{
                                      width: 15,
                                      height: 15,
                                    }}
                                    fontSize={"small"}
                                  />
                                </IconButton>
                              </div>
                            }
                          />
                        </Box>
                      )
                    )}
                </Box>
              </div>
            </TabPanel>
            {values.captureType === "QUESTIONS" && (
              <TabPanel value={this.state.selectedTab} index={1}>
                <div style={{ height: "100%" }}>
                  <StyledTabs
                    value={this.state.valueVerticalTab}
                    onChange={this.handleVerticalTabChange}
                    aria-label="styled tabs example"
                  >
                    <StyledTab label="Items Card" />
                    <StyledTab label="Items Text" />
                  </StyledTabs>

                  <TabPanel value={this.state.valueVerticalTab} index={0}>
                    {this.state.inspectionItems &&
                    this.state.inspectionItems.length > 0 ? (
                      this.state.inspectionItems.map(
                        (item: any, index: any) => (
                          <InspectionCardComponent
                            inspectionData={item}
                            key={index.toString()}
                            index={index}
                            editData={
                              index === this.state.editDataIndex
                                ? this.state.editData
                                : {}
                            }
                            onEdit={this.executeEditComponent}
                            onDelete={this.executeDeleteComponent}
                          />
                        )
                      )
                    ) : (
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          overflow: "auto",
                        }}
                      >
                        <img
                          src={emptyTrash}
                          style={{ width: 40, height: 40 }}
                          alt="Empty Trash"
                        />
                        <Typography
                          variant="h5"
                          gutterBottom
                          style={{ marginTop: 10, textAlign: "center" }}
                        >
                          {"Add Inspection Items".toUpperCase()}
                        </Typography>
                      </div>
                    )}
                  </TabPanel>
                  <TabPanel value={this.state.valueVerticalTab} index={1}>
                    <SortableList
                      items={this.state.inspectionItems}
                      onSortEnd={(props: any) =>
                        this.onSortEnd(props.oldIndex, props.newIndex)
                      }
                      helperClass={classes.sorting}
                    />
                  </TabPanel>
                </div>
              </TabPanel>
            )}
            {values.captureType === "FORMS" && (
              <TabPanel value={this.state.selectedTab} index={1}>
                <FormControlLabel
                  style={{
                    marginLeft: 10,
                    height: 50,
                  }}
                  disabled={this.state.formsItems.length > 1 ? true : false}
                  control={
                    <Checkbox
                      id={"isDynamic"}
                      name={"isDynamic"}
                      checked={values.isDynamic ? values.isDynamic : ""}
                      onChange={(event: any) => {
                        setFieldValue("isDynamic", event.target.checked);
                      }}
                      value={"isDynamic"}
                    />
                  }
                  label={this.state.formsItems.length > 1 ? "Fixed" : "Dynamic"}
                />
                <Divider />
                {this.state.formsItems && this.state.formsItems.length > 0 ? (
                  <List dense={true}>
                    {this.state.formsItems.map((item: any, index: any) => {
                      return (
                        <FormsCardComponent
                          formsInputItems={item}
                          key={index.toString()}
                          index={index}
                          editData={
                            index === this.state.editDataIndex
                              ? this.state.editData
                              : {}
                          }
                          onEdit={this.executeEditFormsComponent}
                          onDelete={this.executeDeleteFormsComponent}
                        />
                      );
                    })}
                  </List>
                ) : (
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "auto",
                    }}
                  >
                    <img
                      src={emptyTrash}
                      style={{ width: 40, height: 40 }}
                      alt="Empty Trash"
                    />
                    <Typography
                      variant="h5"
                      gutterBottom
                      style={{ marginTop: 10, textAlign: "center" }}
                    >
                      {"Add Inspection Items".toUpperCase()}
                    </Typography>
                  </div>
                )}
              </TabPanel>
            )}
          </main>
        </div>
      </Form>
    );
  };

  render() {
    const {
      open,
      handleClose,
      editData,
      parentWorkflowData,
      classes,
      companyData,
    } = this.props;
    return (
      <React.Fragment>
        <Dialog fullScreen open={open} onClose={handleClose}>
          <Formik
            enableReinitialize={true}
            initialValues={
              editData && !isEmpty(editData)
                ? editData
                : parentWorkflowData && !isEmpty(parentWorkflowData)
                ? parentWorkflowData
                : {
                    uniquIdentifier: getAcronym(
                      companyData && companyData.name ? companyData.name : ""
                    ),
                    captureType: "",
                    name: "",
                    frequency: "",
                    inspectionType: "",
                    otherValue: "",
                    category: "",
                    applicationType: "",
                    operationType: "",
                    equipment: "",
                    activityflow: false,
                    breakdown: false,
                    standing: false,
                    linkedToStepRetrieveOption: false,
                    headerItems: [],
                    notesItems: [],
                    signotoriesItems: [],
                    inspectionsItems: [],
                    formsItems: [],
                    isDynamic: false,
                    roleBase: false,
                    equipmentBase: false,
                    rolesAssigned: undefined,
                  }
            }
            onSubmit={(values, { resetForm }) => {
              this.handleOnSubmit(values);
              // resetForm();
            }}
          >
            {({
              values,
              handleChange,
              handleBlur,
              errors,
              touched,
              setFieldValue,
            }) => (
              <div>
                {this.renderForm(
                  values,
                  handleChange,
                  handleBlur,
                  errors,
                  touched,
                  setFieldValue
                )}
                {this.state.selectedTab === 1 &&
                  values.captureType === "QUESTIONS" && (
                    <Fab
                      aria-label={"Add"}
                      className={classes.fab}
                      color={"primary"}
                      onClick={() => this.handleAddInspectionItem()}
                    >
                      <AddIcon />
                    </Fab>
                  )}
                {this.state.selectedTab === 1 &&
                  values.captureType === "FORMS" && (
                    <Fab
                      aria-label={"Add"}
                      className={classes.fab}
                      color={"primary"}
                      onClick={() => this.handleAddFormsItem()}
                    >
                      <AddIcon />
                    </Fab>
                  )}
              </div>
            )}
          </Formik>

          <LoadingComponents isLoading={this.state.isLoading} />
          {this.renderErrorDialog()}
          {this.renderConfirmDialog()}
          {this.renderImagesDialog()}
          {this.renderAddLegendItemDialog()}
          {this.renderAddHeaderItemDialog()}
          {this.renderAddNotesItemDialog()}
          {this.renderAddSignotoriesItemDialog()}
          {this.renderAddInspectionItemDialog()}
          {this.renderAddFormsItemDialog()}
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddInspectionDialog);
